import { connectBankBodySchema, type ConnectBankBody } from '@klopotun/contracts';
import { useState, type FormEvent } from 'react';
import { Button, TextField } from '../../../../shared/ui/index.js';
import styles from './bank-connect-form.module.css';

type BankConnectFormProps = {
  busy: boolean;
  errorMessage: string | null;
  submitLabel: string;
  onSubmit: (body: ConnectBankBody) => void;
};

const TOKEN_HINT = 'Токен дає лише читання: баланс і виписку. Відкликати його можна там само.';

export const BankConnectForm = ({
  busy,
  errorMessage,
  submitLabel,
  onSubmit,
}: BankConnectFormProps) => {
  const [token, setToken] = useState('');
  const [isTokenInvalid, setIsTokenInvalid] = useState(false);

  const submit = (event: FormEvent<HTMLFormElement>): void => {
    event.preventDefault();

    const parsed = connectBankBodySchema.safeParse({ token });

    setIsTokenInvalid(!parsed.success);

    if (parsed.success) {
      onSubmit(parsed.data);
    }
  };

  return (
    <form className={styles.form} noValidate onSubmit={submit}>
      <ol className={styles.steps}>
        <li>Відкрийте на комп'ютері api.monobank.ua</li>
        <li>Відскануйте QR-код застосунком monobank і підтвердьте</li>
        <li>Скопіюйте токен зі сторінки й вставте сюди</li>
      </ol>

      <TextField
        label="Токен monobank"
        name="bank-token"
        type="password"
        autoComplete="off"
        value={token}
        hint={TOKEN_HINT}
        error={isTokenInvalid ? 'Вставте токен повністю, без пробілів усередині' : undefined}
        disabled={busy}
        onChange={(event) => {
          setToken(event.target.value);
        }}
      />

      {errorMessage !== null && (
        <p className={styles.error} role="alert">
          {errorMessage}
        </p>
      )}

      <Button type="submit" busy={busy}>
        {submitLabel}
      </Button>
    </form>
  );
};
